// src/App.jsx
import React from "react";
import { ChakraProvider, defaultSystem, Box } from "@chakra-ui/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ProspectState from "./context/prospect/ProspectState";

import Navbar from "./components/navigation/Navbar";
import Footer from "./components/navigation/Footer";

import Home from "./components/pages/Home";
import CompaniesList from "./components/pages/CompaniesList";
import Blogs from "./components/pages/Blog";
import Calculator from "./components/pages/Calculator";
import ProfilePage from "./components/pages/ProfilePage";
import BlogContent from "./components/pages/BlogContent";

// New/renamed pages to match footer
import HowWeReview from "./components/pages/HowWeReview";
import DataSources from "./components/pages/DataSources";
import AboutUs from "./components/pages/AboutUs";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsOfUse from "./components/pages/TermsOfUse";
import AdvertiserDisclosure from "./components/pages/AdvertiserDisclosure";
// (Optional) sitemap
import Sitemap from "./components/pages/Sitemap";

export default function App() {
  return (
    <ChakraProvider value={defaultSystem}>
      <ProspectState>
        <Router>
          <Box minH="100dvh" bg={{ base: "white", _dark: "gray.900" }}>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tax-relief-companies" element={<CompaniesList />} />
              <Route
                path="/tax-relief-companies/:slug"
                element={<ProfilePage />}
              />
              <Route path="/tax-relief-blog" element={<Blogs />} />
              <Route path="/tax-relief-blog/:slug" element={<BlogContent />} />
              <Route path="/tax-relief-calculator" element={<Calculator />} />

              {/* Footer-aligned pages */}
              <Route path="/how-we-review" element={<HowWeReview />} />
              <Route path="/data-sources" element={<DataSources />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route
                path="/advertiser-disclosure"
                element={<AdvertiserDisclosure />}
              />
              <Route path="/sitemap" element={<Sitemap />} />
            </Routes>
            <Footer />
          </Box>
        </Router>
      </ProspectState>
    </ChakraProvider>
  );
}
